/* eslint-disable import/no-cycle */
import React from 'react';
import { OptionsManager } from '../formElements/options/OptionsManager';
import { QuestionValidationRules } from '../formElements/questionValidationRules/QuestionValidationRules';
import { ScreeningType } from '../formElements/ScreeningType';
import { QuestionRequireResponse } from '../formElements/QuestionRequireResponse';
import { SCREENING_TYPE } from '../../../questionnaireTemplate.enums';
import { QuestionnaireBuilderElementProps } from '../../../questionnaireTemplate.types';

export const MultiChoiceWithImage = React.memo(function MultiChoiceWithImage({ elementId }: QuestionnaireBuilderElementProps) {
  return (
    <>
      <OptionsManager elementId={elementId} />
      <QuestionValidationRules elementId={elementId} />
      <ScreeningType id={elementId} screeningTypes={[SCREENING_TYPE.NONE, SCREENING_TYPE.KNOKOUT, SCREENING_TYPE.REVIEW]} />
      <QuestionRequireResponse elementId={elementId} />
    </>
  );
});
